import { Link, useLocation } from "react-router-dom";
import Logo from "../../icons/logo";
import { useTranslation } from "react-i18next";
import ChangeLang from "./changeLanguage";
import MessagePopup from "../popups/messagePopup";
import { useState } from "react";
import UserIcon from "../../icons/userIcon";

const Header = () => {
  const { t } = useTranslation();
  const [login, setLogin] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  
  const UserType = (
    <>
      {/* <h2 className="my-5 text-2xl font-bold text-center text-mainRed">
        {t("loginAs")}
      </h2>
      <div className="flex justify-between gap-4">
        <Link
          className="flex w-full h-[80px] justify-center hover:opacity-70 items-center gap-2 text-lg font-bold border border-mainBlue text-mainBlue px-3 py-2 rounded-[10px]"
          to={"/employee/dashboard"}
        >
          <UserIcon fill={"#0051ff"} />
          {t("employee")}
        </Link>
        <Link
          className="flex w-full h-[80px] justify-center hover:opacity-70 items-center gap-2 text-lg font-bold border border-mainBlue text-mainBlue px-3 py-2 rounded-[10px]"
          to={"/agent/dashboard"}
        >
          <UserIcon fill={"#0051ff"} />
          {t("agent")}
        </Link>
      </div> */}

      <div className="flex flex-col items-center justify-center text-center p-6 sm:p-10 max-w-md mx-auto">
  
  {/* أيقونة التنبيه المتحركة بجلفية دائرية ناعمة */}
  <div className="relative flex items-center justify-center w-20 h-20 bg-amber-50 rounded-full mb-6 animate-bounce" style={{ animationDuration: '3s' }}>
    <span className="absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-20 animate-ping"></span>
    <span className="text-4xl">⚠️</span>
  </div>

  {/* النص الرئيسي للرسالة */}
  <h3 className="text-2xl font-extrabold text-slate-800 mb-3 tracking-wide">
    النظام تحت التطوير
  </h3>
  
  {/* النص الفرعي التوضيحي */}
  <p className="text-base text-slate-500 leading-relaxed max-w-[280px] sm:max-w-none">
    نحن نعمل حالياً على تحسين وتحديث المنصة لتقديم أفضل تجربة مستخدم ممكنة. شكراً لـ تفهمكم وصبركم.
  </p>

  {/* خط ديكوري بسيط وفخم في الأسفل */}
  <div className="w-16 h-1 bg-gradient-to-r from-amber-400 to-amber-500 rounded-full mt-6 opacity-60"></div>
  
</div>
    </>
  );

  const { pathname } = useLocation();
  
  return (
    <header className="py-4 bg-white relative z-50">
      <div className="flex items-center justify-between w-11/12 mx-auto">
        <div>
          <Logo />
        </div>

        {/* زر الهامبرغر للشاشات الصغيرة */}
        <button 
          onClick={() => setIsOpen(!isOpen)} 
          className="xl:hidden flex flex-col justify-between w-6 h-5 cursor-pointer order-last xl:order-none ml-4"
        >
          <span className={`h-0.5 w-full bg-black transition-all ${isOpen ? "transform rotate-45 translate-y-2" : ""}`}></span>
          <span className={`h-0.5 w-full bg-black transition-all ${isOpen ? "opacity-0" : ""}`}></span>
          <span className={`h-0.5 w-full bg-black transition-all ${isOpen ? "transform -rotate-45 -translate-y-2" : ""}`}></span>
        </button>

        {/* القائمة البرمجية */}
        <nav className={`
          fixed xl:static top-[72px] right-0 left-0 bg-white shadow-md xl:shadow-none 
          flex flex-col xl:flex-row items-center gap-4 xl:gap-6 font-medium lg:text-lg text-capitalize 
          p-6 xl:p-0 transition-all duration-300 w-full xl:w-auto
          ${isOpen ? "flex" : "hidden xl:flex"}
        `}>
          <Link
            className={`${pathname === "/" ? "text-mainBlue" : "text-black"}`}
            to="/"
            onClick={() => setIsOpen(false)}
          >
            {t("home")}
          </Link>
          <Link
            className={`${pathname.startsWith("/services") ? "text-mainBlue" : "text-black"}`}
            to="/services"
            onClick={() => setIsOpen(false)}
          >
            {t("services")}
          </Link>
          <Link
            className={`${pathname.startsWith("/offer-price") ? "text-mainBlue" : "text-black"}`}
            to="/offer-price"
            onClick={() => setIsOpen(false)}
          >
            {t("offerPrice")}
          </Link>
          <Link
            className={`${pathname.startsWith("/tools") ? "text-mainBlue" : "text-black"}`}
            to="/tools"
            onClick={() => setIsOpen(false)}
          >
            {t("tools")}
          </Link>
          <Link
            className={`${pathname.startsWith("/blogs") ? "text-mainBlue" : "text-black"}`}
            to="/blogs"
            onClick={() => setIsOpen(false)}
          >
            {t("blogs")}
          </Link>
          <Link
            className={`${pathname.startsWith("/about-Us") ? "text-mainBlue" : "text-black"}`}
            to="/about-Us"
            onClick={() => setIsOpen(false)}
          >
            {t("aboutUs")}
          </Link>
          {/* <Link
            className={`${pathname.startsWith("/bloog") ? "text-mainBlue" : "text-black"}`}
            to="bloog"
            onClick={() => setIsOpen(false)}
          >
            {t("blog")}
          </Link> */}
        </nav>

        <div className="flex items-center gap-2 ml-auto xl:ml-0">
          <button
            onClick={() => setLogin(true)}
            className="block text-mainGray hover:underline pulse px-3 py-2 rounded-[10px]"
          >
            {t("login")}
          </button>
          <Link
            to={"/auth"}
            className="bg-mainBlue block text-white rounded-[10px] hover:bg-mainBlue/90 px-3 py-2 "
          >
            {t("signUp")}
          </Link>

          <div className="z-50">
            <ChangeLang />
          </div>
        </div>

        <MessagePopup
          noTimer
          setState={setLogin}
          state={login}
          text={UserType}
          containerClassName={"w-[90%] md:w-[50%] h-[400px]"}
        />
      </div>
    </header>
  );
};

export default Header;